import { apiService } from "./apiService";
import apiRoutes from "./apiRoutes";

export const getSubscribersList = async () => {
    const response = await apiService.get(apiRoutes.adminSubscribersList);
    return response.data;
};

export const deleteSubscriber = async (data) => {
    const response = await apiService.post(apiRoutes.adminDeleteSubscriber, data);
    return response.data;
};

export const getSubscriptionsPackage = async () => {
    const response = await apiService.get(apiRoutes.adminSubscriptionsPackage);
    return response.data;
};


export const updateSubscriptionPackage = async (data) => {
    const response = await apiService.post(apiRoutes.adminUpdateSubscriptionPackage, data);
    return response.data;
};